import { FuneralHome } from '~/types/IDeceasedContact';
import { siteAxios } from '~/App/helpers/http';

export const funeralHome = {
  search: async (q: string) => {
    const { data } = await siteAxios.get<FuneralHome[]>(
      '/api/v2/mw/bitnet/funeral_homes',
      {
        params: {
          q
        }
      }
    );

    return data;
  }
};
